/**
 * Container for All Punch View
 */
import React, { useState, useEffect, useRef } from "react";
import { 
  Alert, 
  Button, 
  Dialog, 
  DialogActions, 
  DialogContent, 
  DialogContentText, 
  DialogTitle,
  CircularProgress, 
  Grid,
  Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import { mkConfig, generateCsv, download} from "export-to-csv";
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import { makeStyles} from "@material-ui/core";
import moment from "moment";
import { dateConfig, SET_EMPTY } from "config";
import {SPACE} from 'config/CONSTANTS';
import {jobTypeITContractor} from 'utils';
import {
  date,
  time,
  getHighDurationWorkerRecords
} from "utils/report";
import { Link, useLocation } from "react-router-dom";
import {CONTRACTOR_TIMESHEET} from '../../../navigation/CONSTANTS'
import {
  PENDING_STATUS,
  INCOMPLETE_BG_INVALID,
  INCOMPLETE_BG_VALID,
} from "config";
import { approvePunch, deletePunch } from "services";
import { useHistory } from "react-router-dom";
import { OTHER_TEAM } from "config/CONSTANTS";
import { properCase } from "../../../utils";
import { useDispatch } from "react-redux";
import {
  selectedWeekOnReview,
} from "redux/actions/appActions";

import {
  DURATION_GT_12,
  TWELVE,
} from "../../../config/index";
import NoData from "utils/NoData";

export const HighDurationAllPunchesView = (props) => {
  console.log("propsL:", props);
  const history = useHistory();
  const dispatch = useDispatch();
  const SUCCESS_MSG_SHOWTIME = 5000;
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(true);
  const [loadingError, setLoadingError] = useState(SET_EMPTY);
  const [data, setData] = useState([]);
  const [rowsSelected, setRowsSelected] = useState([]);
  const [selectedPunches, setSelectedPunches] = useState([]);
  const [isApproveLoading, setIsApproveLoading] = useState(false);
  const [approveError, setApproveError] = useState("");
  const [approveSuccess, setApproveSuccess] = useState("");
  const [isDeleteLoading, setIsDeleteLoading] = useState(false);
  const [deleteError, setDeleteError] = useState("");
  const [deleteSuccess, setDeleteSuccess] = useState("");
  const dispath = useDispatch();
  const { allPunchViewFiltersData } = useSelector((state) => state.appConfig);
  //console.log("------allPunchViewFiltersData-------",allPunchViewFiltersData);

  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
  });
  const { user, isLoading: userLoading } = useSelector(
    (state) => state.user.auth
  );
  const blank = properCase(t("pgReview.tableStaticText.blank"));

  const useStyles = makeStyles((theme) => ({
    dialog: {
      padding: theme.spacing(2),
      position: "absolute",
      top: theme.spacing(5),
    },
    dialogContent: {
      textAlign: "left",
    },
    dialogAction: {
      justifyContent: "flex",
    },
    hideElem: {
      display: "none",
    },
    container: {
      marginTop: 10,
      background: "#1B75BC",
      color: "white",
      fontSize: 16,
      fontWeight: "bolder",
      minHeight: 40,
      width: "100%",
      lineHeight: 3,
    },
    label1: {
      marginLeft: 80,
    },
    label2: {
      marginLeft: 30,
      width: "100%",
    },
  }));
  const {approveForManager,selectedTeam,imtRole} = props;
  const classes = useStyles();
  const location = useLocation();
  const { isReportView, isHighDuration, dataProp } = location.state || {};

  useEffect(() => {
    setIsLoading(true);
    setLoadingError(SET_EMPTY);

    if (user.workerId && !userLoading) {
      let startDate, endDate;
      if (props.weekStartDate) {
        startDate = moment(props.weekStartDate).toISOString();
        endDate = moment(new Date(props.weekStartDate))
          .add(7, "days")
          .toISOString();
      }
     if (dataProp && dataProp.length > 0) {
        setData(dataProp);
        setLoadingError(SET_EMPTY);
        setIsLoading(false);
      } else {
        const fromDate = moment()
          .subtract(2, "weeks")
          .startOf("week")
          .format("YYYY-MM-DD");
        const toDate = moment()
          .add(2, "weeks")
          .startOf("week")
          .format("YYYY-MM-DD");

          let userWorkerId = selectedTeam === OTHER_TEAM ? approveForManager.managerId : user.workerId

        getHighDurationWorkerRecords(userWorkerId, fromDate, toDate).then(
          (data) => {
            console.log(
              "Activity high duration Group report data in else",
              data
            );


            if (data && data.length > 0) {


              let filterData = [...data]
              if(selectedTeam === OTHER_TEAM){

        
                    let delegateFor = user?.delegateFor;
                    if ((!(delegateFor && approveForManager &&
                      delegateFor.includes(approveForManager.managerId))) &&
        
                       ((imtRole && imtRole !== "" && imtRole.toLowerCase() === "supervisor")
        
                        || (!imtRole && user.isApprover))) {
                          
                          
                          filterData = filterData.filter(item => item.worker && 

                            item.worker.approvingManager && item.worker.approvingManager.includes(user.workerId) )
                            console.log("filterData",filterData);
                        }
                      }

              setData(filterData);
              setLoadingError(SET_EMPTY);
              setIsLoading(false);
            } else {
              setIsLoading(false);
              setLoadingError("pgReview.noPunchesToReport");
            }
          }
        );
      }
    } else if (userLoading) {
      setIsLoading(false);
      console.log("Continue loading google user's data from IRM DB!");
    } else {
      setIsLoading(false);
      setLoadingError("pgReview.errLoadingWorkerId");
      console.log(
        "ReportView: else in getWorkerByMgr condition: No Logged in worker details found!"
      );
    }
  }, [userLoading, props.weekStartDate, props.selectedTeam ,approveForManager]);

  /**
   * function to update the selected punch Id
   * @return: {void}
   */
  const onRowSelectionChange = (currentRows, allRows, rowsSelected) => {
    console.log("onRowSelectionChange: ", currentRows, allRows, rowsSelected);

    let newSelectedPunches = [];
    rowsSelected.map((n) => {
      newSelectedPunches.push(data[n].id);
    });
    setSelectedPunches(newSelectedPunches);
    setRowsSelected(rowsSelected);
    console.log("Selected Punches ", newSelectedPunches);
  };

  /**
   * function to check if a punch record is selectable
   * @return: {boolean}
   */
  const isRowSelectable = (dataIndex, selectedRows, objects) => {
    console.log("isRowSelectable: ", dataIndex, selectedRows, objects);
    if (data[dataIndex]) {
      let selectable = [PENDING_STATUS];
      if (selectable.indexOf(data[dataIndex].status) >= 0) return true;
      else return false;
    }
  };

  /**
   * function to approve selected punch records.
   * @return: {void}
   */
  const approveHandler = () => {
    const punchIds = selectedPunches;
    const approvedPunchIndexes = [];
    console.log("AllPunchView: approveHandler: punchRecords=", punchIds);
    setIsApproveLoading(true);
    setApproveError("");
    // Check if any punch records are selected for approval.
    if (punchIds.length > 0) {
      approvePunch(punchIds, user.workerId)
        .then((punchData) => {
          data.map((item, index) => {
            if (selectedPunches.indexOf(item.id) >= 0) {
              item.status = "approved";
              approvedPunchIndexes.push(index);
            }
          });
          setIsApproveLoading(false);
          setApproveError("");
          setSelectedPunches([]); // Reset selected Punches.
          setRowsSelected([]);
          setApproveSuccess("pgReview.msgApproveSuccess");
          setTimeout(() => setApproveSuccess(""), SUCCESS_MSG_SHOWTIME);
          console.log("PUNCHES APPROVED===", punchData);
        })
        .catch((err) => {
          console.error("Err in approval of punches: ", err);
          setIsApproveLoading(false);
          setApproveError("pgReview.errApprovingPunchRecords");
        });
    } else {
      setIsApproveLoading(false);
      setApproveError("pgReview.errNothingToApprove");
    }
  };

  /**
   * function to delete selected punch records.
   * @return: {void}
   */
  const deleteHandler = () => {
    const punchIds = selectedPunches;
    let deletedPunchIndexes = [];
    console.log("AllPunchView: deleteHandler: punchRecords=", punchIds);
    setIsDeleteLoading(true);
    setDeleteError("");
    // Check if any punch records are selected for deletion.
    if (punchIds.length > 0) {
      deletePunch(punchIds, user.workerId)
        .then((punchData) => {
          data.map((item, index) => {
            if (selectedPunches.indexOf(item.id) >= 0) {
              deletedPunchIndexes.push(index);
            }
          });
          setIsDeleteLoading(false);
          setDeleteError("");
          setSelectedPunches([]); // Reset selected Punches.
          setRowsSelected([]);
          setDeleteSuccess("pgReview.msgDeleteSuccess");
          setTimeout(() => setDeleteSuccess(""), SUCCESS_MSG_SHOWTIME);
          console.log("PUNCHES DELETED===", punchData);
          handleDeleteRows();
          setConfirmDialog({ ...confirmDialog, isOpen: false });
        })
        .catch((err) => {
          console.error("Err in deletion of punches: ", err);
          setIsDeleteLoading(false);
          setDeleteError("pgReview.errDeletingPunchRecords");
        });
    } else {
      setIsDeleteLoading(false);
      setDeleteError("pgReview.errNothingToDelete"); //to be done translations in all lan
    }
  };

  /**
   * function to delete selected punch records from frontend.
   * @return: {void}
   */
  const handleDeleteRows = () => {
    const punchIds = selectedPunches;
    if (punchIds.length > 0) {
      for (let i = 0; i < punchIds.length; i++) {
        const punchId = punchIds[i];
        data.map((item, index) => {
          if (punchId === item.id) {
            data.splice(index, 1);
          }
        });
      }
      setData(data);
      setSelectedPunches([]); // Reset selected Punches.
      setRowsSelected([]);
      console.log("Handle Delete Rows Completed.");
    }
  };
  
  const csvConfig = mkConfig({
    fieldSeparator:',',
    decimalSeparator: '.',
    columnHeaders: [
      {
        key: "workerId",
        displayLabel: "Worker Id"
      },
      {
        key: "name",
        displayLabel: "Name"
      },
      {
        key: "jobName",
        displayLabel: "Job Role"
      },
      {
        key: "activityGroup",
        displayLabel: "Activity Group"
      },
      {
        key: "buildingId",
        displayLabel: "Building Id"
      },
      {
        key: "jobProjectInfo",
        displayLabel: "Project Info"
      },
      {
        key: "exceptionName",
        displayLabel: "Exception Type"
      },
      {
        key: "duration",
        displayLabel: "Duration"
      },
      {
        key: "status",
        displayLabel: "Status"
      },
      {
        key: "startDate",
        displayLabel: "Start Date"
      },
      {
        key: "startTime",
        displayLabel: "Start Time"
      },
      {
        key: "endDate",
        displayLabel: "End Date"
      },
      {
        key: "endTime",
        displayLabel: "End Time"
      },
    ],
    filename:'All_Activities',
  })
  const handleExportData = () =>{
    let mappedRow = data.map(({workerId, name, jobName, activityGroup, buildingId, jobProjectInfo, exceptionName, duration, status, startDate, startTime,
      endDate, endTime
    })=>({workerId, name, jobName, activityGroup, buildingId, jobProjectInfo, exceptionName, duration, status, startDate, startTime,
      endDate, endTime}));
    
    console.log("rowData", mappedRow);
    const csv = generateCsv(csvConfig)(mappedRow);
    download(csvConfig)(csv);
  }
  const columns = [

   {
    accessorKey: "name",
    header: properCase(t("pgReview.tableHeads.name")),
      size :70,
      enableColumnDragging: false,
      display: true,
      filter: true,
      filterList: allPunchViewFiltersData[1].length
        ? allPunchViewFiltersData[1]
        : null,
    
  },
   {
  accessorKey: "jobName",
  header:  properCase(t("pgReview.tableHeads.jobFamily")),
      size :60,
      display: true,
      filter: true,
      filterList: allPunchViewFiltersData[2].jobFamily
        ? allPunchViewFiltersData[2]
        : null,
   },  
    {
      accessorKey: "activityGroup",
      header: properCase(t("pgReview.tableHeads.activityGroup")),
      enableColumnDragging: false,
      size :70,
      display: true,
      filter: true,
      filterList: allPunchViewFiltersData[3].length
        ? allPunchViewFiltersData[3]
        : null,
        Cell:({renderedCellValue, row}) =>{
          let dataIndex = row.index;
          let value = data[dataIndex].activityGroup;
           if(value) {         
          if (value.toUpperCase() === "TRANSACTIONAL")
          {
           return properCase(t("pgHome.reportlabel2Transcational"))
          } 
          else if (value.toUpperCase() === "PROJECT"){
           return  properCase(t("pgHome.reprotlabel3Project"))
          }
          else if(value.toUpperCase() === "NON-TRANSACTIONAL"){
           return properCase(t("pgHome.reportlabel1Non-Transactional"))
          }
          else if(value.toUpperCase() === "LEAVE"){
            return properCase(t("other.lblLeave"))
           }
           else if(value.toUpperCase() === "MEAL"){
            return properCase(t("other.tlMeal"))
           }
          else if(value.toUpperCase() === "BUILDING MOVES"){
            return properCase(t("other.tlbuildingmoves"))
           }
          }  
           else {
            return "NA"; 
          }
          
        }
   },
 {
      accessorKey: "buildingId",
      header: properCase(t("pgReview.tableHeads.buildingId")),
      display: true,
      size :70,
      filter: false,
      filterList: allPunchViewFiltersData[4].length
        ? allPunchViewFiltersData[4]
        : null,
  },
{
      accessorKey: "jobProjectInfo",
      header: properCase(t("pgReview.tableHeads.projectInfo")),
      size :70,
      display: true,
      filter: true,
      filterList: allPunchViewFiltersData[5].length
        ? allPunchViewFiltersData[5]
        : null,
   
      customFilterListOptions: {
        render: (v) => (v !== SET_EMPTY ? v : blank),
      },
  },
{
    accessorKey: "exceptionName",
    header: properCase(t("pgReview.tableHeads.exceptionType")),
    
      display: true,
      filter: true,
      filterList: allPunchViewFiltersData[6].length
        ? allPunchViewFiltersData[6]
        : null,
        enableColumnDragging: false,
     filterOptions: {
        renderValue: (v) =>
          v === "no exception" || v === SET_EMPTY ? blank : v,
      },
      Cell:({renderedCellValue, row}) =>{
        let dataIndex = row.index;
        let value = data[dataIndex].exceptionName;
        if (value) {
        if (value.toUpperCase() === "MISSED CLOCK IN")
        {
          return properCase(t("pgPunch.btnMissedClockedIn"))
        }
         else if (value.toUpperCase() === "MISSED CLOCK OUT")
        {
          return properCase(t("pgPunch.btnMissedClockedOut"))
        }
       } else {
          return value === "no exception" ? SET_EMPTY : value;
        }          
      },
  },
{
    accessorKey: "inLocalTS",
    header: properCase(t("pgReview.tableHeads.startDate")),
     sort: true,
      display: true,
      filter: true,
      filterList: allPunchViewFiltersData[7].length
        ? allPunchViewFiltersData[7]
        : null,
        Cell: ({ row }) => {
          let value = row.original.inLocalTS;
          return date(value);
        },
      
   
  },
  {
      accessorKey: "startTime",
      header: properCase(t("pgReview.tableHeads.startTime")),
      size: 50,
      sort: true,
      Cell: ({ row }) => {
        let value = row.original.inLocalTS;
        return time(value);
    }
  }, 
  {
    accessorKey: "outLocalTS",
    header: properCase(t("pgReview.tableHeads.endTime")),
    size: 50,
    sort: true,
    Cell: ({ row }) => {
      let value = row.original.outLocalTS;
      return time(value);
    },
  },
  {
    accessorKey: "duration",
    header: properCase(t("pgReview.tableHeads.duration")),
     sort: true,
      display: true,
      filter: true,
      filterList: allPunchViewFiltersData[11].length
        ? allPunchViewFiltersData[11]
        : null,
  },
  {
    accessorKey: "status",
    header: properCase(t("pgReview.tableHeads.status")),
     sort: true,
      display: true,
      filter: true,
      filterList: allPunchViewFiltersData[12].length
        ? allPunchViewFiltersData[12]
        : null,
        Cell:({renderedCellValue, row}) =>{
          let dataIndex = row.index;
          let value = data[dataIndex];
          const rowData = row.original;
          console.log("rowData",rowData)
          if (data[dataIndex]) {
            const { status, statusException, jobName, worker } = rowData;
            let pathDetails = {};
            if( worker && worker.jobType && worker.jobType == jobTypeITContractor){  
              pathDetails = {
                pathname : CONTRACTOR_TIMESHEET,
                state : {
                  worker:{...worker, name:worker?.firstName+SPACE+worker?.lastName}
                }
              }
              
            }else{
              pathDetails = {
                pathname: "/timesheet",
                state: {
                  punch: data[dataIndex],
                  selectedWorker: data[dataIndex]["worker"],
                  isHighDuration: true,
                }
              }
             }
          const statusLink = (
            <>
              {/* {APPROVED_STATUS.toUpperCase() === status.toUpperCase() || statusException ? ( // ENMO-949 to edit approved */}
              {
               statusException ? (
               status &&
               status.toUpperCase() === "PENDING" ?                   
                properCase(t("other.lblPending")) :

                status.toUpperCase() === "AUTO APPROVED" ?
                properCase(t("other.lblAutoApproved")) :

                status.toUpperCase() === "APPROVED" ?                   
                properCase(t("other.lblApproved")) :
                   
                status.toUpperCase()
              ) : (
                <Link
                  title={t("pgReview.tableStaticText.btnEdit")}
                  style={{ textDecoration: "none", color: "#1b75bc" }}
                  to={pathDetails}
                  onClick={() => {
                    var weekStart = moment(
                      data[dataIndex].inLocalTS
                    ).format();
                    console.log(
                      " in Link WEEK SELECTION: weekStart: ",
                      weekStart
                    );

                    dispatch(selectedWeekOnReview({ week: weekStart }));
                  }}
                >
                  <Typography variant="body2">
                    {
                   // status.toUpperCase()
                    status &&

                    status.toUpperCase() === "PENDING" ?                   
                    properCase(t("other.lblPending")) :

                    status.toUpperCase() === "AUTO APPROVED" ?
                    properCase(t("other.lblAutoApproved")) :

                    status.toUpperCase() === "APPROVED" ?                   
                    properCase(t("other.lblApproved")) :
                      
                    status.toUpperCase()
                    }
                  </Typography>
                </Link>
              )}
            </>
          );
          return statusLink;
                 
          }
           
        }
   
  },
  

];
     let indexArray = [];
     let totalDurationRef = useRef();
     let Tot = 0;
  const table = useMaterialReactTable({
    renderTopToolbarCustomActions: () => {
      return (
        <Grid container style={{
          gap:"20px",
          alignItems:"flex-end",
          margin:"5px 20px 0 20px",
          justifyContent:"space-between",
        }}>
          <Typography variant="h6" sx={{color: "#58595B"}}>
            {properCase(t("other.ReviewHighDuration"))}
            </Typography>
          <Button
             disabled={table.getPrePaginationRowModel().rows.length === 0}
            //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
            onClick={()=>
              handleExportData(table.getPrePaginationRowModel().rows)
            }
            startIcon={<FileDownloadIcon />}
          >
            Export
          </Button>
          </Grid>
          
       );
    },
    columns,
    data: data,
    localization:{
      noRecordsToDisplay: <NoData/>,
      noResultsFound: <NoData/>
    },
    state:{
      isLoading: isLoading,
      showProgressBars: isLoading
    },
    muiCircularProgressProps:{
      sx:{
        ".MuiCircularProgress-circle":{
          transition:'none'
        }
      },
      variant: 'determinate'
    },
    muiSkeletonProps:{
      animation:'wave',
      height: 20
    },
    enablePagination: true,
    enableGrouping: true,
    defaultColumn: {
      minSize: 150,
    },
    columnResizeMode: "onChange",
    muiTableBodyCellProps: {
      align: "left",
    },
    muiTableHeadCellProps: {
      align: "left",
    },
    enableColumnPinning: true,
    enableStickyHeader: true,
    muiPaginationProps: {
      rowsPerPageOptions: [10, 25, 50, 100],
      showRowsPerPage: true,
    },
    initialState: {
      density: "compact",
      pagination: {
        pageSize: 50,
      },
    },
    
    muiTableBodyRowProps: ({row}) => {
     let dataIndex = row.index;
      const bgWithinRange = INCOMPLETE_BG_VALID;
      const bgOutOfRange = INCOMPLETE_BG_INVALID;
       if (data[dataIndex]) {
        let tempTot = parseFloat(parseFloat(data[dataIndex].duration) + Tot);
        if (!indexArray.includes(dataIndex)) {
          indexArray.push(dataIndex);
          setTotalDuration(tempTot);
        }
        if (parseFloat(data[dataIndex].duration) > TWELVE) {
          return {
           sx:{
              backgroundColor: DURATION_GT_12
            }
          };
        }
        const { endDate, endTime, startDate, startTime } = row.original;
        console.log("timeing 2",endDate,endTime,startDate,startTime)
        if (!(endDate && endTime && startDate && startTime)) {
          console.log("timeing 3",endDate,endTime,startDate,startTime)
          let applyColor =
            startDate &&
            moment().diff(moment(startDate, dateConfig.format3), "days") > 14
              ? bgOutOfRange
              : bgWithinRange;
              
          return {
            sx:{
              backgroundColor: applyColor
            }

          };
        }
        return {};
      }
      },
  });
  const setTotalDuration = (val) => {
    Tot = val;
    if (totalDurationRef.current) {
      totalDurationRef.current.innerText = parseFloat(Tot).toFixed(2);
    }
  };

  return (
    <>
      {/* {
        loadingError ? (
          <Typography variant="body2" color="error">
            {t(loadingError)}
            <Alert severity="info">{t(loadingError)}</Alert>
          </Typography>
        ) : null
        allPunchMarkup
      } */}
      {/* <div className={loadingError ? classes.hideElem : ""}> */}
        <>
               <MaterialReactTable table={table} />
          {/* <Grid container justify={"flex-end"} spacing={3}>
             <Grid item>
               <Box my={8}>
                 <LoadingButton
                   onClick={() =>
                     setConfirmDialog({
                       isOpen: true,
                     })
                   } //{deleteHandler}
                   isLoading={isDeleteLoading}
                   disabled={rowsSelected.length <= 0}
                 >
                   {t("pgReview.btnDelete")}
                 </LoadingButton>
                 <Typography variant="body2" color="error">
                   {t(deleteError)}
                 </Typography>
                 <Typography variant="body2">{t(deleteSuccess)}</Typography>
               </Box>
             </Grid>
             <Grid item>
               <Box my={8}>
                 <LoadingButton
                   onClick={approveHandler}
                   isLoading={isApproveLoading}
                   disabled={rowsSelected.length <= 0}
                 >
                   {t("pgReview.btnApprove")}
                 </LoadingButton>
                 <Typography variant="body2" color="error">
                   {t(approveError)}
                 </Typography>
                 <Typography variant="body2">{t(approveSuccess)}</Typography>
               </Box>
             </Grid>
           </Grid> */}
          <Dialog
            open={confirmDialog.isOpen}
            className={classes.dialog}
            disableBackdropClick
          >
            <DialogTitle id="form-dialog-title">
              {t("pgPunch.tlConfirmation")}
            </DialogTitle>
            <DialogContent>
              <DialogContentText>
                {t("pgReview.msgDeleteConfirmation")}
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                variant="contained"
                color="primary"
                onClick={deleteHandler}
              >
                {t("pgReview.btnYes")}
              </Button>
              <Button
                color="primary"
                onClick={() =>
                  setConfirmDialog({ ...confirmDialog, isOpen: false })
                }
              >
                {t("pgReview.btnNo")}
              </Button>
            </DialogActions>
          </Dialog>
        </>
      {/* </div> */}
    </>
  );
};

HighDurationAllPunchesView.propTypes = {
  weekStartDate: PropTypes.any.isRequired,
  allWorkers: PropTypes.object.isRequired,
  selectedTeam: PropTypes.string.isRequired,
};
export default HighDurationAllPunchesView;
